import { useState } from 'react';
import { useDidUpdateEffect } from './useDidUpdateEffect';
import { useVariable } from './useVariable';
import { useInput } from './useInput';
export var useInputWithReady = function useInputWithReady(value, defaultValue, onChange, multiple, equalValues, needSortArrays, onBeforeOutsideChange, onBeforeInsideChange, ready, onReady) {
  if (ready === void 0) {
    ready = true;
  }

  var _useInput = useInput(value, defaultValue, onChange, multiple, equalValues, needSortArrays, onBeforeOutsideChange, onBeforeInsideChange),
      internalInitialValue = _useInput[0],
      setValue = _useInput[1],
      internalValueRef = _useInput[2];

  var _useState = useState(ready),
      internalReady = _useState[0],
      setInternalReady = _useState[1];

  var handleReady = useVariable(onReady); // handle ready

  useDidUpdateEffect(function () {
    if (ready) {
      handleReady.current == null ? void 0 : handleReady.current(internalValueRef.current);
    }

    setInternalReady(ready);
  }, [ready]);
  var internalValue = !internalReady ? null : internalInitialValue;
  return [internalValue, setValue, internalValueRef];
};